import React from "react";
import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SettingsProvider } from "@/lib/settings";

import Portal from "@/pages/Portal";
import FileViewer from "@/pages/FileViewer";
import Verify from "@/pages/Verify";
import Bottle from "@/pages/Bottle";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminCodes from "@/pages/admin/AdminCodes";
import AdminFiles from "@/pages/admin/AdminFiles";
import AdminSettings from "@/pages/admin/AdminSettings";
import PrintSheet from "@/pages/admin/PrintSheet";
import RequireAdmin from "@/pages/admin/RequireAdmin";

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Portal />} />
            <Route path="/view" element={<FileViewer />} />
            <Route path="/bottle" element={<Bottle />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <RequireAdmin>
                  <AdminLayout />
                </RequireAdmin>
              }
            >
              <Route index element={<Navigate to="overview" replace /> } />
              <Route path="overview" element={<AdminOverview />} />
              <Route path="codes" element={<AdminCodes />} />
              <Route path="files" element={<AdminFiles />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
            <Route
              path="/admin/sheet"
              element={
                <RequireAdmin>
                  <PrintSheet />
                </RequireAdmin>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
